import {Button} from '@/components/ui/button/Button'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Copy01Icon, DotsHorizontalIcon, Trash01Icon} from '@/components/ui/icon/Icon'
import {Menu, MenuGroup, MenuItem} from '@/components/ui/menu-atoms/MenuAtoms'
import {useTranslation} from '@/translations/i18n'
import {MenuButton, MenuProvider} from '@ariakit/react'
import {useState} from 'react'
import {DeleteTreatmentRequestModal} from '@/features/treatment-requests/components/delete-treatment-request-modal/DeleteTreatmentRequestModal'
import {TreatmentRequestSmall, TreatmentRequestExtended} from '@/features/treatment-requests/types'
import {useNavigate} from 'react-router-dom'
import {routes} from '@/utilities/constants/routes'
import {TreatmentRequestOptionsCta} from '@/features/treatment-requests/components/treatment-request-details-options-cta/TreatmentRequestOptionsCta'
import {usePermissions} from '@/features/auth/store/store'

export const TreatmentRequestDetailsOptions = ({treatmentRequest}: {treatmentRequest: TreatmentRequestExtended}) => {
    const {t} = useTranslation()
    const [isDeleteTreatmentRequestModalOpen, setIsDeleteTreatmentRequestModalOpen] = useState(false)
    const navigate = useNavigate()
    const permissions = usePermissions()
    return (
        <>
            <Flexbox gap={2}>
                {(treatmentRequest.status == 'in_progress' || treatmentRequest.status == 'accepted') && (
                    <TreatmentRequestOptionsCta
                        patientId={treatmentRequest.patientId}
                        project={treatmentRequest.project}
                        hasAuthorizedDate={!!treatmentRequest.authorizationDate}
                    />
                )}
                {permissions?.requests?.write && (
                    <MenuProvider>
                        <MenuButton
                            render={
                                <Button variant="secondary" shape="square">
                                    <DotsHorizontalIcon />
                                </Button>
                            }
                        />
                        <Menu>
                            <MenuGroup>
                                <MenuItem
                                    onClick={() =>
                                        navigate({
                                            pathname: routes.CREATE_TREATMENT_REQUEST.handle.path,
                                            search: `?treatment_request_id=${treatmentRequest.id}`
                                        })
                                    }
                                >
                                    <Copy01Icon />
                                    {t('commons:duplicate')}
                                </MenuItem>
                                <MenuItem variant="danger" onClick={() => setIsDeleteTreatmentRequestModalOpen(true)}>
                                    <Trash01Icon />
                                    {t('commons:delete')}
                                </MenuItem>
                            </MenuGroup>
                        </Menu>
                    </MenuProvider>
                )}
            </Flexbox>

            {isDeleteTreatmentRequestModalOpen && (
                <DeleteTreatmentRequestModal
                    treatmentRequest={TreatmentRequestSmall.parse(treatmentRequest)}
                    onClose={() => setIsDeleteTreatmentRequestModalOpen(false)}
                    onSuccess={() => navigate(-1)}
                />
            )}
        </>
    )
}
